var installedModules = {};
var moduleToHandlerMapping = {
	36520: {
		getter: function() { return Promise.all([__webpack_require__.e(9704), __webpack_require__.e(165), __webpack_require__.e(9288), __webpack_require__.e(1965)]).then(function() { return function() { return __webpack_require__(39288); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	53781: {
		getter: function() { return __webpack_require__.e(4291).then(function() { return function() { return __webpack_require__(44291); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	44281: {
		getter: function() { return Promise.all([__webpack_require__.e(9704), __webpack_require__.e(2298)]).then(function() { return function() { return __webpack_require__(9917); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	45431: {
		getter: function() { return Promise.all([__webpack_require__.e(165), __webpack_require__.e(1965), __webpack_require__.e(7673)]).then(function() { return function() { return __webpack_require__(52106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	50741: {
		getter: function() { return Promise.all([__webpack_require__.e(724), __webpack_require__.e(1965), __webpack_require__.e(8872)]).then(function() { return function() { return __webpack_require__(70724); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	8173: {
		getter: function() { return __webpack_require__.e(3500).then(function() { return function() { return __webpack_require__(43500); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	12974: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(63159); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	67077: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(11855); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	75124: {
		getter: function() { return __webpack_require__.e(8775).then(function() { return function() { return __webpack_require__(88775); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	225: {
		getter: function() { return __webpack_require__.e(9578).then(function() { return function() { return __webpack_require__(59578); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	59442: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(97922); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	41965: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(9388); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	91812: {
		getter: function() { return __webpack_require__.e(5057).then(function() { return function() { return __webpack_require__(25057); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/utils/app-logger/appLogger",
	},
	31032: {
		getter: function() { return __webpack_require__.e(5647).then(function() { return function() { return __webpack_require__(5647); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.51.16",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	29740: {
		getter: function() { return __webpack_require__.e(1511).then(function() { return function() { return __webpack_require__(71511); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/entities/tracking/lib/bootstrap-signals",
	},
	40597: {
		getter: function() { return __webpack_require__.e(8527).then(function() { return function() { return __webpack_require__(98527); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-flows/context",
	},
	6906: {
		getter: function() { return __webpack_require__.e(7306).then(function() { return function() { return __webpack_require__(44925); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/providers/TrackingProvider",
	},
	66215: {
		getter: function() { return __webpack_require__.e(9917).then(function() { return function() { return __webpack_require__(9917); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	90321: {
		getter: function() { return __webpack_require__.e(8319).then(function() { return function() { return __webpack_require__(20700); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-abtests/providers/ABTestExperimentsProvider",
	},
	3130: {
		getter: function() { return Promise.all([__webpack_require__.e(540), __webpack_require__.e(5146), __webpack_require__.e(4675)]).then(function() { return function() { return __webpack_require__(37056); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/providers/AppProvider",
	},
	15708: {
		getter: function() { return Promise.all([__webpack_require__.e(749), __webpack_require__.e(4469)]).then(function() { return function() { return __webpack_require__(44469); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/providers/BannerProvider",
	},
	34556: {
		getter: function() { return __webpack_require__.e(4799).then(function() { return function() { return __webpack_require__(64799); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/providers/LoadingOverlayProvider",
	},
	24363: {
		getter: function() { return __webpack_require__.e(4291).then(function() { return function() { return __webpack_require__(44291); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	86617: {
		getter: function() { return __webpack_require__.e(5161).then(function() { return function() { return __webpack_require__(25161); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "../../packages/tn-foundation/entities/dma/hooks/useDMA",
	},
	97401: {
		getter: function() { return __webpack_require__.e(3500).then(function() { return function() { return __webpack_require__(43500); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	22769: {
		getter: function() { return Promise.all([__webpack_require__.e(724), __webpack_require__.e(8057)]).then(function() { return function() { return __webpack_require__(70724); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	75939: {
		getter: function() { return __webpack_require__.e(2106).then(function() { return function() { return __webpack_require__(52106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	}
};
var initialConsumes = [36520,53781,44281,45431,50741,8173,12974,67077,75124,225,12974,67077,59442,41965,31032,40597,91812,6906,66215,36520,29740,90321,3130,15708,34556,24363,86617,97401,22769,75939];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"636": [
		31032,
		40597,
		91812,
		6906,
		66215,
		36520,
		29740,
		90321,
		3130,
		15708,
		34556,
		24363,
		86617
	],
	"1812": [
		91812
	],
	"1965": [
		41965
	],
	"2769": [
		22769
	],
	"4925": [
		29740
	],
	"5274": [
		75939
	],
	"5527": [
		53781,
		44281,
		45431,
		50741,
		8173,
		12974,
		67077,
		75124,
		225
	],
	"6396": [
		31032
	],
	"6520": [
		36520
	],
	"7401": [
		97401
	],
	"8792": [
		12974,
		67077,
		59442,
		41965
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}